import { BaseModel, convertToArrayModels, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import ArticleMainItem from './ArticleMainItem'

export default class ArticleMainSection extends BaseModel {
  static override constructorName = 'ArticleMainSection'

  id: number = 0
  name: string = ''
  sort: number = 0
  link: string = ''
  items: ArticleMainItem[] = []

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data, ['items'])

      this.items = convertToArrayModels(data.items, ArticleMainItem)
    }
  }
}

registerModel(ArticleMainSection)
